import { platformMyDayHostCapability, platformMyDayHostSlots, } from '@crest/platform-contracts/hosts';
import { timesheetsSettingRegistrations } from '../settings/timesheets-setting-definitions.js';
import { timesheetsModuleManifest } from '../timesheets.module.js';
import { timesheetsActivityReviewHostCapability, timesheetsActivityReviewHostSlots, } from '../contracts/timesheets-activity-review-host.contract.js';
async function testRouteParamsReader() {
    if (typeof window !== 'undefined')
        return undefined;
    try {
        const routerPackage = 'react-router-dom';
        const router = await import(routerPackage);
        return router.useParams;
    }
    catch {
        return undefined;
    }
}
export const timesheetsWebModuleContribution = {
    moduleId: 'timesheets',
    manifest: timesheetsModuleManifest,
    settingRegistrations: timesheetsSettingRegistrations,
    settingEditors: [],
    hostContracts: [{
            capability: timesheetsActivityReviewHostCapability,
            slots: Object.values(timesheetsActivityReviewHostSlots),
        }],
    hostContributions: [{
            id: 'timesheets.web.platform.my-day',
            moduleId: 'timesheets',
            slot: platformMyDayHostSlots.primary,
            contractVersion: platformMyDayHostCapability,
            requiredPermission: 'timesheets.clock.read-own',
            settingCondition: null,
            priority: 10,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            load: () => import('./timesheets-my-day.panel.js'),
        }],
    routes: [
        {
            id: 'timesheets.web.clock',
            moduleId: 'timesheets',
            path: '/timesheets/clock',
            requiredPermission: 'timesheets.clock.read-own',
            navigation: {
                id: 'timesheets.navigation.clock',
                fallbackLabel: 'Time Clock',
                labelConfigurationKey: 'timesheets.copy.clock',
                labelValueProperty: 'navigationLabel',
                priority: 30,
            },
            load: () => import('./timesheets-clock.page.js'),
        },
        {
            id: 'timesheets.web.activity-review',
            moduleId: 'timesheets',
            path: '/timesheets/activity-review',
            requiredPermission: 'timesheets.entries.read-all',
            navigation: {
                id: 'timesheets.navigation.activity-review',
                fallbackLabel: 'Timesheets',
                labelConfigurationKey: 'timesheets.copy.activity-review',
                labelValueProperty: 'navigationLabel',
                priority: 31,
            },
            load: () => import('./timesheets-activity-review.page.js'),
        },
        {
            id: 'timesheets.web.lunch-review',
            moduleId: 'timesheets',
            path: '/timesheets/lunch-review',
            requiredPermission: 'timesheets.lunch-corrections.read-all',
            navigation: {
                id: 'timesheets.navigation.lunch-review',
                fallbackLabel: 'Lunch review',
                labelConfigurationKey: 'timesheets.copy.lunch-review',
                labelValueProperty: 'navigationLabel',
                priority: 32,
            },
            load: () => import('./timesheets-lunch-review.page.js'),
        },
        {
            id: 'timesheets.web.location-review',
            moduleId: 'timesheets',
            path: '/timesheets/location-review',
            requiredPermission: 'timesheets.location.read-all',
            navigation: {
                id: 'timesheets.navigation.location-review',
                fallbackLabel: 'Location review',
                labelConfigurationKey: 'timesheets.copy.location-review',
                labelValueProperty: 'navigationLabel',
                priority: 33,
            },
            load: () => import('./timesheets-location-review.page.js'),
        },
        {
            id: 'timesheets.web.entry-split',
            moduleId: 'timesheets',
            path: '/timesheets/entry-split',
            requiredPermission: 'timesheets.entries.split',
            navigation: {
                id: 'timesheets.navigation.entry-split',
                fallbackLabel: 'Split time entries',
                labelConfigurationKey: 'timesheets.copy.entry-split',
                labelValueProperty: 'navigationLabel',
                priority: 34,
            },
            load: () => import('./timesheets-entry-split.page.js'),
        },
        {
            id: 'timesheets.web.lunch-correction-review-target',
            moduleId: 'timesheets',
            path: '/timesheets/lunch-review/date/:workDate/member/:membershipId/request/:requestId',
            requiredPermission: 'timesheets.lunch-corrections.read-all',
            navigation: null,
            load: async () => {
                const [page, readParams] = await Promise.all([
                    import('./timesheets-lunch-review.page.js'),
                    testRouteParamsReader(),
                ]);
                return {
                    default: () => page.TimesheetsLunchCorrectionReviewTargetPage(readParams?.()),
                };
            },
        },
        {
            id: 'timesheets.web.missing-lunch-report-target',
            moduleId: 'timesheets',
            path: '/timesheets/lunch-review/date/:workDate/report/:reportRunId',
            requiredPermission: 'timesheets.lunch-reports.read',
            navigation: null,
            load: async () => {
                const [page, readParams] = await Promise.all([
                    import('./timesheets-lunch-review.page.js'),
                    testRouteParamsReader(),
                ]);
                return {
                    default: () => page.TimesheetsMissingLunchReportTargetPage(readParams?.()),
                };
            },
        },
    ],
};
export default timesheetsWebModuleContribution;
//# sourceMappingURL=timesheets-web.module-contribution.js.map